import MapDetails from 'layouts/Desktop/containers/MapDetails'
import DesktopWarehouse from './containers/DesktopWarehouse'
import SubMenu from './containers/DesktopWarehouse/SubMenu'
import { Switch, Redirect, Route } from 'react-router-dom'
import GateGateway from 'containers/entrance/GateGateway'
import Registration from 'containers/forms/Registration'
import PaymentStatus from 'containers/PaymentStatus'
import OrderContract from 'containers/OrderContract'
import OrderSummary from 'containers/OrderSummary'
import NewWarehouse from 'containers/NewWarehouse'
import FirstOpening from 'containers/FirstOpening'
import OrderDetails from 'containers/OrderDetails'
import Contract from 'containers/forms/Contract'
import Warehouses from './containers/Warehouses'
import Shared from 'containers/entrance/Shared'
import Billing from 'containers/forms/Billing'
import Categories from 'containers/Categories'
import Dashboard from 'containers/Dashboard'
import Google from 'containers/OAuth/Google'
import Apple from 'containers/OAuth/Apple'
import DesktopMRoute from './DesktopMRoute'
import Reset from 'containers/forms/Reset'
import Account from './containers/Account'
import PlaceMap from 'containers/PlaceMap'
import StartPage from 'layouts/StartPage'
import Payment from 'containers/Payment'
import Help from './containers/Help'
import Login from 'containers/Login'
import Chats from 'containers/Chats'
import Home from 'containers/Home'
import Maps from 'containers/Maps'
import Shop from 'containers/Shop'

const applicationForExternalCompanies = process.env.REACT_APP_TYPE !== 'mm'

const Router = () => {
  return (
    <Switch>
      <DesktopMRoute exact path='/' darkNavBar={false} showMenuOnlyWhenUserIsLoggedIn>
        <StartPage />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/account/:key/:action', '/account/:key', '/account']} >
        <Account />
      </DesktopMRoute>

      <DesktopMRoute exact path='/categories'>
        <Categories isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/chat/:id', '/chat']} maxHeight>
        <Chats />
      </DesktopMRoute>

      <DesktopMRoute exact path='/contract' protectedPath>
        <Contract isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path='/dashboard' >
        <Dashboard />
      </DesktopMRoute>

      <Route exact path={['/firstopening/:id/:key', '/firstopening/:id']} protectedPath>
        <FirstOpening />
      </Route>

      <DesktopMRoute exact path='/help' bottomBar>
        <Help />
      </DesktopMRoute>

      <DesktopMRoute exact path='/home' darkNavBar={false} showMenuOnlyWhenUserIsLoggedIn>
        <Home />
      </DesktopMRoute>

      <DesktopMRoute exact path='/login'>
        <Login isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path='/login/reset'>
        <Reset />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/map/:placeId', '/map']} darkNavBar isSearch>
        <Maps isMobile={false} />
      </DesktopMRoute>

      {applicationForExternalCompanies
        ? <DesktopMRoute exact path='/mapdetails/:placeId' showMenuOnlyWhenUserIsLoggedIn>
          <MapDetails type='default' />
        </DesktopMRoute>
        : <DesktopMRoute exact path='/mapdetails/:placeId' darkNavBar isSearch>
          <Maps isMobile={false} />
        </DesktopMRoute>}

      <DesktopMRoute exact path={['/newwarehouse/:key/:id', '/newwarehouse/:key', '/newwarehouse']} protectedPath isMenu={false} isOrder>
        <NewWarehouse />
      </DesktopMRoute>

      <DesktopMRoute exact path='/oauth/apple' isBasket isOrder>
        <Apple />
      </DesktopMRoute>

      <DesktopMRoute exact path='/oauth/goggle' isBasket isOrder>
        <Google />
      </DesktopMRoute>

      <DesktopMRoute exact path='/order/billing' protectedPath isBasket isOrder>
        <Billing isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path='/order/contract' protectedPath isBasket isOrder>
        <OrderContract />
      </DesktopMRoute>

      <DesktopMRoute exact path='/order/payment' protectedPath isBasket isOrder>
        <Payment />
      </DesktopMRoute>

      <DesktopMRoute exact path='/order/summary' protectedPath isBasket isOrder>
        <OrderSummary />
      </DesktopMRoute>

      <DesktopMRoute exact path='/order/:id' isBasket isOrder>
        <OrderDetails isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/order/:cartId/equipment/:equipmentId/:categoryId', '/order/:cartId/equipment/:equipmentId', '/order/:cartId/shop/:categoryId', '/order/:cartId/shop', '/shop/:warehouseId', '/shop']} darkHeader animation={false}>
        <Shop isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path='/payment/status' protectedPath isBasket isOrder>
        <PaymentStatus />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/placemap/:placeId/:id', '/placemap/:placeId']} isMenu={false} isOrder>
        <PlaceMap />
      </DesktopMRoute>

      <DesktopMRoute exact path='/registration'>
        <Registration isDesktop />
      </DesktopMRoute>

      <DesktopMRoute exact path='/shared/:hash' isBasket isOrder>
        <Shared />
      </DesktopMRoute>

      <DesktopMRoute exact path='/warehouses' protectedPath>
        <Warehouses />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/warehouses/:id']} maxHeight protectedPath>
        <DesktopWarehouse />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/warehouses/:id/gate', '/warehouses/:id/gateway']} maxHeight protectedPath>
        <GateGateway />
      </DesktopMRoute>

      <DesktopMRoute exact path={['/warehouses/:id/:type/:action', '/warehouses/:id/:type']} maxHeight protectedPath>
        <SubMenu />
      </DesktopMRoute>

      <Redirect to='/' />
    </Switch>
  )
}

export default Router